(() => {
  if (window.customCartNotificationEventDateV1) return;
  window.customCartNotificationEventDateV1 = true;
  const anchor = document.querySelector('#cart-notification-button');
  if (!anchor) return;
  const area = document.createElement('div');
  area.className = 'custom-cart-notification-event-date-v1';
  area.innerHTML = '<label for="CustomNotificationEventDate">Event date</label><input id="CustomNotificationEventDate" type="text" inputmode="numeric" placeholder="MM/DD/YYYY" maxlength="10" autocomplete="off" aria-describedby="CustomEventDateError"><label class="custom-event-date-none-v1"><input type="checkbox" id="CustomNotificationNoEventDate">No event date</label><p id="CustomEventDateError" role="alert" hidden></p>';
  anchor.after(area);
  const field = area.querySelector('input[type=text]');
  const none = area.querySelector('input[type=checkbox]');
  const error = area.querySelector('[role=alert]');
  let edited = false;
  let pending = Promise.resolve();
  const root = window.Shopify?.routes?.root || '/';
  const valid = () => {
    if (none.checked || !field.value.trim()) return true;
    const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(field.value.trim());
    if (!match) return false;
    const [, month, day, year] = match.map(Number);
    const date = new Date(year, month - 1, day);
    return year >= 1000 && date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
  };
  const save = () => {
    if (!valid()) {
      error.textContent = 'Enter a valid date as MM/DD/YYYY.';
      error.hidden = false;
      return Promise.resolve(false);
    }
    error.hidden = true;
    const attributes = { 'Event date': none.checked ? '' : field.value.trim(), 'No event date': none.checked ? 'Yes' : '' };
    pending = pending.catch(() => {}).then(async () => {
      const response = await fetch(`${root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes }) });
      if (!response.ok) throw new Error('Event date could not be saved.');
      return true;
    }).catch(() => {
      error.textContent = 'Could not save your event date. Please try again.';
      error.hidden = false;
      return false;
    });
    return pending;
  };
  field.addEventListener('input', () => {
    edited = true;
    const digits = field.value.replace(/\D/g, '').slice(0, 8);
    field.value = [digits.slice(0, 2), digits.slice(2, 4), digits.slice(4)].filter(Boolean).join('/');
  });
  field.addEventListener('change', save);
  none.addEventListener('change', () => { edited = true; field.disabled = none.checked; save(); });
  fetch(`${root}cart.js`).then((r) => r.json()).then((cart) => {
    if (edited) return;
    field.value = cart.attributes?.['Event date'] || '';
    none.checked = cart.attributes?.['No event date'] === 'Yes';
    field.disabled = none.checked;
  }).catch(() => {});
  const form = document.querySelector('#cart-notification-form');
  form?.addEventListener('submit', async (event) => {
    if (!edited && !field.value && !none.checked) return;
    event.preventDefault();
    if (await save()) {
      const checkout = document.createElement('input');
      checkout.type = 'hidden'; checkout.name = 'checkout'; checkout.value = '';
      form.append(checkout);
      HTMLFormElement.prototype.submit.call(form);
    } else field.focus();
  });
})();
